export default "__VITE_ASSET__GC20fNTr__"